/* Pick-your-own colours (Sean 2026-10-20) — markup: snippets/zbm-pick-own.liquid, pool JSON: templates/collection.zbpick.liquid.
   Only in-stock colours are offered (live on load). Before adding to cart every pick is re-checked; a colour that sold out in the
   meantime is removed with a short message and the customer picks another — the rest of the picks stay. No stock numbers anywhere. */
(function () {
  'use strict';
  function txt(s) { return String(s == null ? '' : s); }
  function parse(p) {
    /* "Leafgel Color Gel 515 Raspberry Red [Earth Color]" → 515 / Raspberry Red / Earth Color; "Gel Monsta GMC05  - Dark Tan" → GMC05 / Dark Tan */
    var t = txt(p.t).replace(/^(leafgel\s+(premium\s+)?colou?r\s+gel|gel\s+monsta)\s*/i, '');
    var series = '';
    t = t.replace(/\s*\[([^\]]+)\]\s*/g, function (m, s) { series = series || s.trim(); return ' '; }).trim();
    var m = t.match(/^([A-Z]{0,4}[-.]?\d{1,4}[A-Z]?)\s*[-–—:]?\s*(.*)$/i);
    var code = m ? m[1].replace(/[-.]/g, '').toUpperCase() : '';
    var name = m ? m[2].trim() : t;
    return { code: code, name: name || t, series: series };
  }
  function numKey(code) { var n = code.match(/\d+/); return [code.replace(/\d.*$/, ''), n ? parseInt(n[0], 10) : 1e9, code]; }
  function cmp(a, b) { var x = numKey(a.code), y = numKey(b.code); return x[0] < y[0] ? -1 : x[0] > y[0] ? 1 : x[1] - y[1] || (x[2] < y[2] ? -1 : x[2] > y[2] ? 1 : 0); }
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || 'null'); sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }

  function loadPool(url) {
    var sep = url.indexOf('?') < 0 ? '?' : '&';
    function page(n) { return fetch(url + sep + 'page=' + n + '&_=' + Date.now(), { credentials: 'same-origin' }) /* no Accept: json header — Shopify then serves its own collection JSON, not the view */.then(function (r) { if (!r.ok) throw new Error('pool ' + r.status); return r.json(); }); }
    return page(1).then(function (first) {
      var rest = [];
      for (var i = 2; i <= (first.pages || 1); i++) rest.push(page(i));
      return Promise.all(rest).then(function (pages) {
        var all = first.products || [];
        pages.forEach(function (p) { all = all.concat(p.products || []); });
        return all;
      });
    });
  }

  function init(root) {
    if (root._zb) return;
    var N = parseInt(root.getAttribute('data-n'), 10) || 0;
    var poolUrl = root.getAttribute('data-pool');
    var pickVars = txt(root.getAttribute('data-vars')).split(',').filter(Boolean);
    var form = root.closest('form');
    var sheet = root.querySelector('[data-pk-sheet]');
    var grid = root.querySelector('[data-pk-grid]');
    var chipsEl = root.querySelector('[data-pk-chips]');
    var search = root.querySelector('[data-pk-search]');
    var alertEl = root.querySelector('[data-pk-alert]');
    var note = root.querySelector('[data-pk-note]');
    var chosenEl = root.querySelector('[data-pk-chosen]');
    var listIn = root.querySelector('[data-pk-list]');
    var idsIn = root.querySelector('[data-pk-ids]');
    var KEY = 'zbpick:' + root.getAttribute('data-pid');
    var items = [], byId = {}, picked = [], filter = 'all', loaded = null, lastFocus = null;
    var noteDefault = note ? note.textContent : '';
    var zb = root._zb = { passing: false };

    function active() {
      if (!form) return false;
      if (!pickVars.length) return true;
      var idIn = form.querySelector('[name="id"]');
      return !!idIn && pickVars.indexOf(txt(idIn.value)) > -1;
    }
    zb.active = active;

    function syncMode() {
      var on = active();
      root.hidden = !on;
      listIn.disabled = idsIn.disabled = !on || picked.length !== N;
      var stepper = form && form.querySelector('[data-zbm-stepper]');
      var qty = form && form.querySelector('[data-zbm-qty]');
      if (stepper) stepper.style.display = on ? 'none' : (stepper.getAttribute('data-pk-display') || '');
      if (on && qty) qty.value = 1;
      var dyn = form && form.querySelector('.zbm-pd-dynamic');
      if (dyn) dyn.style.display = on ? 'none' : '';
    }

    function load() {
      if (!loaded) {
        loaded = loadPool(poolUrl).then(function (list) {
          items = [];
          byId = {};
          list.forEach(function (p) {
            if (!p.v) return;
            var it = parse(p);
            it.id = String(p.v); it.a = !!p.a; it.img = txt(p.i); it.h = p.h;
            it.type = txt(p.y).replace(/\s*\(.*\)\s*$/, '').replace(/\s+gel$/i, '').trim(); /* "Syrup Gel (Potted)" → "Syrup" */
            it.fam = txt(p.c).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
            it.hay = (it.code + ' ' + it.name + ' ' + it.series + ' ' + it.type + ' ' + it.fam.join(' ')).toLowerCase();
            byId[it.id] = it;
            if (it.a) items.push(it);
          });
          items.sort(cmp);
          /* restore picks from this visit, minus anything no longer available */
          var saved = store(KEY) || [];
          var lost = [];
          picked = [];
          saved.forEach(function (id) { if (byId[id] && byId[id].a) { if (picked.length < N) picked.push(id); } else if (byId[id]) lost.push(byId[id]); });
          if (lost.length) say(lostMsg(lost));
          buildChips();
          render();
          update();
          return items;
        }).catch(function (e) {
          loaded = null;
          grid.innerHTML = '<p class="zbm-small zbm-pick-loading">Couldn’t load colors. Please refresh the page.</p>';
          throw e;
        });
      }
      return loaded;
    }

    function lostMsg(lost) {
      var names = lost.map(function (it) { return it.code + (it.name ? ' ' + it.name : ''); });
      return (names.length === 1 ? names[0] + ' just sold out' : names.join(', ') + ' just sold out') + ' — please pick ' + (names.length === 1 ? 'another color.' : names.length + ' other colors.');
    }
    function say(m) { if (!alertEl) return; alertEl.textContent = m || ''; alertEl.hidden = !m; }

    function buildChips() {
      var fams = {}, series = {}, types = {};
      items.forEach(function (it) { it.fam.forEach(function (f) { fams[f] = 1; }); if (it.series) series[it.series] = 1; if (it.type) types[it.type] = 1; });
      var chips = [['all', 'All']];
      var tl = Object.keys(types).sort();
      if (tl.length > 1) tl.forEach(function (t) { chips.push(['t:' + t, t]); }); /* Color / Glitter / Syrup */
      Object.keys(series).sort().forEach(function (s) { chips.push(['s:' + s, s]); });
      Object.keys(fams).sort().forEach(function (f) { chips.push(['f:' + f, f]); });
      chips.push(['picked', 'Picked']);
      chipsEl.innerHTML = '';
      chips.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'zbm-chip zbm-pick-chip'; b.setAttribute('data-f', c[0]); b.textContent = c[1];
        b.setAttribute('aria-pressed', c[0] === filter ? 'true' : 'false');
        chipsEl.appendChild(b);
      });
    }

    function visible(it) {
      var q = txt(search && search.value).trim().toLowerCase();
      if (q && it.hay.indexOf(q) < 0 && it.code.toLowerCase().replace(/^[a-z]+/, '') !== q.replace(/^[a-z]+/, '')) return false;
      if (filter === 'all') return true;
      if (filter === 'picked') return picked.indexOf(it.id) > -1;
      if (filter.indexOf('t:') === 0) return it.type === filter.slice(2);
      if (filter.indexOf('s:') === 0) return it.series === filter.slice(2);
      if (filter.indexOf('f:') === 0) return it.fam.indexOf(filter.slice(2)) > -1;
      return true;
    }

    function render() {
      var frag = document.createDocumentFragment(), shown = 0;
      items.forEach(function (it, i) {
        if (!visible(it)) return;
        shown++;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'zbm-pick-sw'; b.setAttribute('data-id', it.id);
        b.setAttribute('aria-pressed', picked.indexOf(it.id) > -1 ? 'true' : 'false');
        b.setAttribute('aria-label', it.code + ' ' + it.name);
        var img = document.createElement('img');
        img.src = it.img; img.alt = ''; img.width = 120; img.height = 120;
        img.loading = shown <= 24 ? 'eager' : 'lazy'; img.decoding = 'async';
        var c = document.createElement('span'); c.className = 'zbm-pick-code'; c.textContent = it.code;
        var n = document.createElement('span'); n.className = 'zbm-pick-name'; n.textContent = it.name;
        var ck = document.createElement('span'); ck.className = 'zbm-pick-check'; ck.setAttribute('aria-hidden', 'true');
        b.appendChild(img); b.appendChild(ck); b.appendChild(c); b.appendChild(n);
        frag.appendChild(b);
      });
      grid.innerHTML = '';
      if (!shown) { var p = document.createElement('p'); p.className = 'zbm-small zbm-pick-loading'; p.textContent = filter === 'picked' ? 'No colors picked yet.' : 'No colors match.'; grid.appendChild(p); }
      grid.appendChild(frag);
    }

    function update() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-pk-count]'), function (el) { el.textContent = picked.length; });
      root.classList.toggle('is-full', picked.length >= N);
      Array.prototype.forEach.call(grid.querySelectorAll('.zbm-pick-sw'), function (b) {
        var on = picked.indexOf(b.getAttribute('data-id')) > -1;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-off', !on && picked.length >= N);
      });
      var sorted = picked.map(function (id) { return byId[id]; }).filter(Boolean).sort(cmp);
      listIn.value = sorted.map(function (it) { return (it.code + ' ' + it.name).trim(); }).join(', ');
      idsIn.value = sorted.map(function (it) { return it.id; }).join(',');
      listIn.disabled = idsIn.disabled = !active() || picked.length !== N;
      /* summary on the page: small swatches of what's picked */
      chosenEl.innerHTML = '';
      sorted.forEach(function (it) {
        var s = document.createElement('img');
        s.src = it.img; s.alt = it.code + ' ' + it.name; s.title = it.code + ' ' + it.name; s.width = 32; s.height = 32; s.loading = 'lazy';
        chosenEl.appendChild(s);
      });
      chosenEl.hidden = !sorted.length;
      var openBtn = root.querySelector('[data-pk-open]');
      if (openBtn) openBtn.textContent = picked.length ? 'Edit colors (' + picked.length + ' / ' + N + ')' : 'Pick your ' + N + ' colors';
      if (note) note.textContent = picked.length === N ? 'All ' + N + ' colors picked. You can still swap any of them.' : (picked.length ? 'Pick ' + (N - picked.length) + ' more to add this set to your cart.' : noteDefault);
      store(KEY, picked);
    }

    function toggle(id) {
      var i = picked.indexOf(id);
      if (i > -1) { picked.splice(i, 1); say(''); }
      else if (picked.length >= N) { say('You’ve picked ' + N + '. Tap a picked color to remove it, then choose another.'); return; }
      else { picked.push(id); say(''); }
      update();
      if (filter === 'picked') render();
    }

    function open() {
      lastFocus = document.activeElement;
      sheet.hidden = false;
      document.documentElement.classList.add('zbm-pick-lock');
      load().catch(function () {});
      setTimeout(function () { var x = sheet.querySelector('[data-pk-close]'); if (x) x.focus(); }, 30);
    }
    function close() {
      sheet.hidden = true;
      document.documentElement.classList.remove('zbm-pick-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    zb.open = open;

    /* re-check every pick against live availability right before adding to cart */
    zb.checkout = function (f) {
      var btn = f.querySelector('[data-zbm-add]');
      if (btn) btn.setAttribute('data-busy', '1');
      var done = function () { if (btn) btn.removeAttribute('data-busy'); };
      var go = function () {
        if (picked.length < N) { done(); open(); if (picked.length) say('Pick ' + (N - picked.length) + ' more colors to add this set.'); return; }
        loaded = null;
        load().then(function () {
          done();
          if (picked.length < N) { open(); return; } /* load() already removed sold-out picks and set the message */
          update();
          zb.passing = true;
          if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }, function () {
          done();
          var m = f.querySelector('[data-zbm-form-msg]');
          if (m) { m.textContent = 'Couldn’t check colors right now. Please try again.'; m.hidden = false; }
        });
      };
      if (!loaded) load().then(go, function () { done(); }); else loaded.then(go, function () { done(); });
    };

    grid.addEventListener('click', function (e) { var b = e.target.closest('.zbm-pick-sw'); if (b) toggle(b.getAttribute('data-id')); });
    chipsEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-f]'); if (!b) return;
      filter = b.getAttribute('data-f');
      Array.prototype.forEach.call(chipsEl.children, function (c) { c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); });
      render(); update();
    });
    if (search) search.addEventListener('input', function () { render(); update(); });
    root.querySelector('[data-pk-open]').addEventListener('click', open);
    root.querySelector('[data-pk-close]').addEventListener('click', close);
    root.querySelector('[data-pk-done]').addEventListener('click', close);
    root.querySelector('[data-pk-clear]').addEventListener('click', function () { if (!picked.length) return; if (picked.length > 3 && !window.confirm('Clear all ' + picked.length + ' picked colors?')) return; picked = []; say(''); update(); if (filter === 'picked') render(); });
    sheet.addEventListener('click', function (e) { if (e.target === sheet) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) close(); });
    if (form) form.addEventListener('change', function () { setTimeout(syncMode, 0); });
    /* the variant buttons set the hidden id select from script (no change event), so also watch the id value */
    var idEl = form && form.querySelector('[name="id"]'), lastId = idEl ? idEl.value : '';
    if (idEl && pickVars.length) setInterval(function () { if (idEl.value !== lastId) { lastId = idEl.value; syncMode(); } }, 300);
    var stepper = form && form.querySelector('[data-zbm-stepper]');
    if (stepper) stepper.setAttribute('data-pk-display', stepper.style.display || '');
    syncMode();
    if (active()) load().catch(function () {});
  }

  /* capture phase: runs before the product form's own add-to-cart handler */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector) return;
    var root = f.querySelector('[data-zbm-pick]');
    if (!root || !root._zb || !root._zb.active()) return;
    if (root._zb.passing) { root._zb.passing = false; return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    root._zb.checkout(f);
  }, true);

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-zbm-pick]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
